var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"headBox"},[_c('div',{staticClass:"headLeft"},[_vm._v(" 2026年北京市社会组织服务项目征集填报系统 ")]),_c('div',{staticClass:"headRight"},[_c('p',[_vm._v("欢迎："+_vm._s(_vm.user.organ_name))]),_c('span',{staticClass:"guanb",on:{"click":_vm.sginout}},[_vm._v("退出")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }